import axios from "../config/axiosInstance";
import endpoints from "./endpoints";

export const getProductLeadReports = async (details) => {
  const response = await axios.put(
    endpoints.getProductLeadReportsURL,
    details
  );
  return response;
};